import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function OtUpdate(props){

  const {id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [surData, setSurData] = useState([]);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [otData,setotData]=useState({
        "comments":'',
        "surg_time":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "update-surgery/" + id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }


    const inputHandler = (event) => {
      const { name, value } = event.target;
      const updatedotData = { ...otData, [name]: value };
        setotData(updatedotData);
    };

  const formSubmit = (e) => {
      e.preventDefault();
         const comments = document.getElementById("comments").value;
         const surg_time = document.getElementById("surg_time").value;
         const status = document.getElementById("status").value;
          const _formData = new FormData();
          _formData.append('comments', comments);
          _formData.append('surg_time', surg_time);
          _formData.append('status', status);
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.put(`${baseUrl}update-surgery/${id}/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'New Surgery has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ot-list/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
     const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };


    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.ip.primary_consult.consultant)}
    </h3>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.ip.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip.ip_id}</td>
            <td>{patientData.ip.pat.pat_id}</td>
            <td>{patientData.ip.pat.patient}</td>
            <td>{patientData.ip.pat.gender}</td>
            <td>{patientData.ip.pat.age}</td>
            <td>{patientData.ip.pat.mobile}</td>
            <td>{patientData.ip.admit_date}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-scissors" aria-hidden="true" style={{ color: 'red' }}></i>
      OT Request
    </h3>
      <form>
      <div className="row">
        <div className="col-md-2 ms-1">
          <label htmlFor="Notes Time" className="form-label">Surgery Time : </label>
          <DatePicker className="form-control" name="surg_time" id="surg_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
        <div className="col-md-2 ms-1">
        <label htmlFor="Comments" className="form-label">Comments : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="comments"
          id="comments"
          ></textarea>
        </div>
        <div className="col-md-3 mb-3">
        <label htmlFor="Status" className="form-label">Status: </label>
            <select className="form-control"
              name="status" id="status">
            <option value="1">Pending</option>
            <option value="2">Completed</option>
            <option value="0">Cancelled</option>
            </select>
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>

  </div>
    </section>
    )
}

export default OtUpdate;